var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-input',{attrs:{"label":_vm.linkTitle,"value":_vm.input.account,"autocomplete":'new-channel',"error":this.$v.input.account.$error || !!_vm.error,"custom-error":_vm.customError ? _vm.customError : _vm.error,"show-validate-icons":true,"v":this.$v.input.account},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }